import {Router} from './routes';
const Navigation = Router;
export default Navigation;